export default __webpack_public_path__ + "static/media/haux-icon.407a6bce.svg";